import React, { useState, memo, useEffect, Fragment } from "react";
import { BrowserRouter, Switch, Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Filters } from '../common/Filters';
import { CourceOptionFilters } from './CourceOptionFilters';

toast.configure();
export const Cource = memo((props) => {
  const { cm, item, filters, options, removeCource, isShowText } = props;
  const [editable, setEditable] = useState(false);
  // 初期設定
  const [currentCource, setCurrentCource] = useState(item);
  const [currentCourceTransJa, setCurrentCourceTransJa] = useState([]);
  const [currentCourceTransEn, setCurrentCourceTransEn] = useState([]);
  useEffect(() => {
    currentCource.translations_attributes.map(tran => {
      if (tran.locale === "ja") {
        setCurrentCourceTransJa(tran);
      } else {
        setCurrentCourceTransEn(tran);
      }
    });
  }, []);

  const onChangeCode = e => setCurrentCource({ ...currentCource, code: e.target.value });
  const onChangeSortId = e => setCurrentCource({ ...currentCource, sort_id: e.target.value });
  const onChangeInfo = e => setCurrentCource({ ...currentCource, information: e.target.value });
  const onChangeNote = e => setCurrentCource({ ...currentCource, examnote: e.target.value });
  const onChangeEnabled = () => setCurrentCource({ ...currentCource, enabled: !currentCource.enabled });
  const onChangeJa = e => setCurrentCourceTransJa({ ...currentCourceTransJa, name: e.target.value });
  const onChangeJaDesc = e => setCurrentCourceTransJa({ ...currentCourceTransJa, description: e.target.value });
  const onChangeEn = e => setCurrentCourceTransEn({ ...currentCourceTransEn, name: e.target.value });
  const onChangeEnDesc = e => setCurrentCourceTransEn({ ...currentCourceTransEn, description: e.target.value });
  // codeフォーム設定
  let codeDecorate = editable ?
      <td>
        <input type="number" className="form-control" defaultValue={currentCource.code} onChange={onChangeCode} />
      </td>
      :
      <td>{currentCource.code}</td>;
  // SortIdフォーム設定
  let SordIdDecorate = editable ?
      <td>
        <input type="number" className="form-control" defaultValue={currentCource.sort_id} onChange={onChangeSortId} />
      </td>
      :
      <td>{currentCource.sort_id}</td>;
  // 日本語ラベル・備考フォーム設定
  let nameJaDecorate = editable ? 
      <td>
          <input type="text" className="form-control" defaultValue={currentCourceTransJa.name} onChange={onChangeJa} />
          <input type="text" className="form-control" defaultValue={currentCourceTransJa.description} onChange={onChangeJaDesc} />
      </td>
      :
      <td>
        {currentCourceTransJa.name}
        <br/>
        {(!currentCourceTransJa.description) ? "" : `(${currentCourceTransJa.description})`}
      </td>;
  // 英語ラベル・備考フォーム設定
  let nameEnDecorate = editable ? 
      <td>
          <input type="text" className="form-control" defaultValue={currentCourceTransEn.name} onChange={onChangeEn} />
          <input type="text" className="form-control" defaultValue={currentCourceTransEn.description} onChange={onChangeEnDesc} />
      </td>
      :
      <td>
        {currentCourceTransEn.name}
        <br/>
        {(!currentCourceTransEn.description) ? "" : `(${currentCourceTransEn.description})`}
      </td>;

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  // edit 失敗時のデータ設定
  const setOldData = (item) => {
    setCurrentCource({
      ...currentCource, 
      code: item.code,
      sort_id: item.sort_id 
    });
    item.translations_attributes.map(oldTran => {
      if (oldTran.locale === "ja") {
        setCurrentCourceTransJa({
          ...currentCourceTransJa,
          name: oldTran.name,
          description: oldTran.description
        });
      } else {
        setCurrentCourceTransEn({
          ...currentCourceTransEn,
          name: oldTran.name,
          description: oldTran.description
        });
      }
    });
  }

  const onClickEditSubmit = (id) => {
    if (!currentCource.code || !currentCource.sort_id || !currentCourceTransJa.name || !currentCourceTransEn.name) {
      alert("※入力必須です。");
      return
    }

    if (editable) {
      let mod_item = {item: {
        code: currentCource.code,
        sort_id: currentCource.sort_id,
        translations_attributes: [
          { id: currentCourceTransJa.id, locale: "ja", name: currentCourceTransJa.name.trim(), description: currentCourceTransJa.description.trim() },
          { id: currentCourceTransEn.id, locale: "en", name: currentCourceTransEn.name.trim(), description: currentCourceTransEn.description.trim() }
        ]
      }}

      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

      axios.patch(`/agent/cources/${id}`, mod_item)
      .then(resp => {
        console.log(resp);
        notify("success", "Cource successfully updated!");
      })
      .catch(e => {
        console.log(e.response);
        setOldData(item);
        alert(JSON.parse(e.request.responseText).errors);
        notify("error", "Cource update Error!");
      })
    }
    setEditable(!editable);
  }

  const onClickEnableSubmit = (id) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.put(`/agent/cources/${id}/enabled`)
    .then(resp => {
      onChangeEnabled();
      notify("success", "Cource Enabled successfully updated!");
    })
    .catch(e => {
      console.log(e.response);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Cource Enabled update Error!");
    })
  }

  const onClickDeleteSubmit = (id) => {
    const sure = window.confirm('Are you sure?');
    if (sure) {
      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

      axios.delete(`/agent/cources/${id}`)
      .then(resp => {
        console.log(resp);
        removeCource(id);
        notify("success", "Cource successfully deleted!");
      })
      .catch(e => {
        console.log(e.response);
        notify("error", "Cource delete Error!");
      })
    }
  }

  const onBlurInfoSubmit = (id) => {
    if (item.information === currentCource.information.trim()) {
      return;
    }

    let info_content = {information: { contentsall: currentCource.information.trim() }}

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/cources/${id}/informations`, info_content)
    .then(resp => {
      console.log(resp);
      notify("success", "Information successfully updated!");
    })
    .catch(e => {
      console.log(e.response);
      setCurrentCource({ ...currentCource, information: item.information });
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Information update Error!");
    })
  }

  const onBlurNoteSubmit = (id) => {
    if (item.examnote === currentCource.examnote.trim()) {
      return;
    }

    let note_content = {information: { examnote: currentCource.examnote.trim() }}

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/cources/${id}/informations`, note_content)
    .then(resp => {
      console.log(resp);
      notify("success", "Note successfully updated!");
    })
    .catch(e => {
      console.log(e.response);
      setCurrentCource({ ...currentCource, examnote: item.examnote });
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Note update Error!");
    })
  }

  return (
    <tr>
      {codeDecorate}
      {SordIdDecorate}
      {nameJaDecorate}
      {nameEnDecorate}
      <td>
        <div className={isShowText ? 'd-none' : ''}>
          <button 
            onClick={() => onClickEditSubmit(currentCource.id)} 
            className={editable ? 'btn btn-primary mrb-1'  : 'btn btn-outline-dark mrb-1'}
            title="Edit"
            disabled={(
              !currentCource.code 
              || !currentCource.sort_id 
              || !currentCourceTransJa.name 
              || !currentCourceTransEn.name
            )}
          >
            <i className="far fa-edit" />
          </button>
          <button onClick={() => onClickDeleteSubmit(currentCource.id)} className='btn btn-outline-danger mrb-1' title="Delete" disabled={(editable)}>
            <i className="far fa-trash-alt" />
          </button>
          <button onClick={() => onClickEnableSubmit(currentCource.id)} className={currentCource.enabled ? 'btn btn-outline-info mrb-1' : 'btn btn-warning mrb-1'} title="En/Disabled">
            <i className={currentCource.enabled ? 'fas fa-bell' : 'fas fa-bell-slash'} />
          </button>
          <a className={ (1 <= currentCource.code && currentCource.code <= 79) || (110 <= currentCource.code && currentCource.code <= 119) ? 'btn btn-outline-success mrb-1' : 'btn btn-outline-secondary mrb-1 disabled'} title="コース＆病院別とオプション設定"
            href={`/agent/cources/${currentCource.id}/cource_clinics?company_id=${cm}`}>
            <i className="fas fa-pencil-alt" />
          </a>
          <a className={ (80 <= currentCource.code && currentCource.code <= 99) ? 'btn btn-outline-success mrb-1' : 'btn btn-outline-secondary mrb-1 disabled'} title="コース＆巡回会場設定"
            href={`/agent/cources/${currentCource.id}/cource_venues`}>
            <i className="fas fa-bus-alt" />
          </a>
          <a className={ (120 <= currentCource.code && currentCource.code <= 149) ? 'btn btn-outline-primary mrb-1' : 'btn btn-outline-secondary mrb-1 disabled'} title="朝日生命成人病研究所の枠設定" 
            href={`/agent/cources/${currentCource.id}/cource_items`}>
            <i className="fas fa-clinic-medical" />
          </a>
        </div>
      </td>
      <td>
        <div className={isShowText ? 'd-none' : ''}>
          <div className="mb-1">
            <Filters
              model_id={currentCource.id}
              modelName="cources"
              filters={filters}
              using_filter_ids={currentCource.using_filter_ids}
            />
          </div>
          <div>
            <CourceOptionFilters
              cource_id={currentCource.id}
              options={options}
              using_option_ids={currentCource.using_option_ids}
              disabled={!(120 <= currentCource.code && currentCource.code <= 149)}
            />
          </div>
        </div>
      </td>
      {isShowText ?
        <Fragment>
          <td>
            <textarea placeholder="インフォメーションを入力"
              className="form-control"
              onChange={onChangeInfo}
              onBlur={() => onBlurInfoSubmit(currentCource.id)}
              defaultValue={currentCource.information}></textarea>
          </td>
          <td>
            <textarea placeholder="特記事項を入力"
              className="form-control"
              onChange={onChangeNote}
              onBlur={() => onBlurNoteSubmit(currentCource.id)}
              defaultValue={currentCource.examnote}></textarea>
          </td>
        </Fragment>
      :
        <td colSpan="2"></td>
      }
    </tr>
  );
});
